import {GameFont} from '../../../../shared/scripts/GameFont'
import {UIGameToolTipView} from '../../../../shared/scripts/ui_game/ui_game_tooltip/UIGameToolTipView'

export class UIWGameToolTipView extends UIGameToolTipView {
    protected setConstants() {
        this.titleFont = GameFont.Size.XL
        this.bodyFont = GameFont.Size.L
        this.maxTipWidth = this.itemSize * 2.5
        this.horizontalPadding = this.itemSize * 0.15
        this.titleTopPadding = this.itemSize * 0.1
        this.titleBottomPadding = this.itemSize * 0.05
        this.bodyTopPadding = this.itemSize * 0.1
        this.bodyLineHeight = this.itemSize * 0.27
        this.zIndex = 1
    }
}
